import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
	menuListar,
	verificaMenuRouteGuard,
	verificaPermissao,
	verificaRecursosDaTelaCompleto,
} from "@/api/space/control/authenticator.spaceApi";
import type { ISpaceVerificaPermissaoRequest, ISpaceVerificaRecursoRequest } from "@/api/space/dtos/authenticator.dto";

export const keys_permissoes = {
	base: ["space", "permissoes"] as const,
	menu: () => [...keys_permissoes.base, "menu"] as const,
	verificaPermissao: (req: ISpaceVerificaPermissaoRequest) =>
		[...keys_permissoes.base, "verifica-permissao", req] as const,
	verificaMenuRouteGuard: (tag: string) => [...keys_permissoes.base, "route-guard", tag] as const,
	verificaRecursosDaTelaCompleto: (req: ISpaceVerificaRecursoRequest) =>
		[...keys_permissoes.base, "recursos-da-tela-completo", req] as const,
};

export function useVerificaPermissao(req: ISpaceVerificaPermissaoRequest, enabled = true) {
	const podeConsultarGrupo = req.tipo !== "GRUPO" || Boolean(req.id_cad_grupo_usuario);

	return useQuery({
		queryKey: keys_permissoes.verificaPermissao(req),
		queryFn: () => verificaPermissao(req),
		enabled: enabled && Boolean(req.tag_permissao) && podeConsultarGrupo,
		staleTime: 0, //Sem cache
		gcTime: 0,
	});
}

export function useVerificaRecursosDaTela(req: ISpaceVerificaRecursoRequest, enabled = true) {
	return useQuery({
		queryKey: keys_permissoes.verificaRecursosDaTelaCompleto(req),
		queryFn: () => verificaRecursosDaTelaCompleto(req),
		enabled: enabled && Boolean(req),
		placeholderData: keepPreviousData,
		staleTime: 0, //Sem cache
		gcTime: 0,
	});
}

export function useMenuListar(enabled = true) {
	return useQuery({
		queryKey: keys_permissoes.menu(),
		queryFn: menuListar,
		enabled,
		staleTime: 0, //Sem cache
		gcTime: 0,
	});
}

export function useVerificaMenuRouteGuard(tag: string, enabled = true, silenciarErro = false) {
	return useQuery({
		queryKey: keys_permissoes.verificaMenuRouteGuard(tag),
		queryFn: () => verificaMenuRouteGuard(tag),
		enabled: enabled && Boolean(tag),
		staleTime: 0, //Sem cache
		gcTime: 0,
		meta: silenciarErro ? { silenciarErro: true } : undefined,
	});
}
